const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	currentConversation:null,
	conversations:[],
	currentConversationMessages:[],
	conversationMessages:[]
}
const getters = {
	currentConversationGetter:({currentConversation}) => currentConversation,
	ConversationsGetter:({conversations}) => conversations,
	conversationMessagesGetter:({conversationMessages}) => conversationMessages,
	currentConversationMessagesGetter:({currentConversationMessages}) => currentConversationMessages,
}

const mutations = {
	setCurrentConversation : (state,payload) => state.currentConversation = payload,
	setConversations : (state,payload) => state.conversations = payload,
	setConversationMessages : (state,payload) => state.conversationMessages = payload,
	setCurrentConversationMessages : (state,payload) => state.currentConversationMessages = payload,
}

const actions = {
	async fetchCurrentConversation({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/current-conversation`).then(response => {
			commit('setCurrentConversation',response.data.result)
		}).catch(error => {})
	},
	async fetchConversations({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/conversations`).then(response => {
			commit('setConversations',response.data.result.data)
		}).catch(error => {})
	},
	async fetchConversationMessages({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/conversations/${payload.conversationID}/messages`).then(response => {
			if(payload.conversationID === state.currentConversation.id ){
				commit('setCurrentConversationMessages',response.data.result.data.reverse())
			}else{
				commit('setConversationMessages',response.data.result.data.reverse())
			}

		}).catch(error => {})
	},
	async startConversation({commit,state}, payload){
		var params = {admin_id: payload.adminID}
		await this.$axios.post(`${BASE_API}/start-conversation`,params).then(response => {
			commit('setCurrentConversation',response.data.result)
		}).catch(error => {})
	},
	async sentConversationMessage({commit,state}, payload){
		var params = {...payload}
		await this.$axios.post(`${BASE_API}/conversations/${payload.conversation_id}/messages`,params).then(response => {
		}).catch(error => {})
	},
	async readMessage({commit,state}, payload){
		await this.$axios.post(`${BASE_API}/conversations/${payload.conversation_id}/messages/${payload.message_id}/read`)
	}

}

export default {namespaced:true,state,getters,mutations,actions}
